import React from "react";
import { Box, Link } from "theme-ui";
import { PromoBlockCard } from './promoblock';
import { promoBlockStyle } from "./style";
import { getSlugfiedText } from "../../helpers/general";

// Styles
import { SxStyleProp } from 'theme-ui';

interface ThreePromoBlocksProps {
  cards: PromoBlockCard[]
}

const ThreePromoBlocksStyle: { [k: string]: SxStyleProp } = {
  cardGrid: {
    'a': {
      display: 'block',
      marginTop: '30px'
    },
    'a:first-of-type': {
      marginTop: '0'
    }
  },
  grid: {
    justifyContent: 'space-between',
    marginTop: '40px',

    'article': {
      minHeight: '0',
    },

    '> div, > a': {
      width: 'calc(50% - 15px)',

      '@media only screen and (max-width: 768px)': {
        width: '100%',
      }
    },

    '.--is-small-card article': {
      minHeight: 'unset',
    },

    '.--is-big-card article': {
      height: '100%',

      '@media only screen and (max-width: 768px)': {
        height: '300px',
        marginBottom: '30px',
      }
    }
  },
  link: {
    color: 'var(--theme-ui-colors-text,#000)',
    textDecoration: 'none',
  }
};

const customBg = (card: PromoBlockCard) =>
  card?.background?.localFile?.publicURL
  ? {
    backgroundImage: `url(${card.background.localFile?.publicURL})`,
  }
  : {}
;

const renderCard = (card: PromoBlockCard, smallCard = false) =>
  <Link
    className={`card card-link ${smallCard ? '--is-small-card' : '--is-big-card'}`}
    key={getSlugfiedText(card.link.url)}
    href={card.link.url}
    target={card.link.target ? '_blank' : '_self'}
    title={card?.title}
    sx={ThreePromoBlocksStyle.link}
  >
    <Box
      as="article"
      className="card-body"
      key={getSlugfiedText(card.excerpt)}
      sx={promoBlockStyle.card}
      style={customBg(card)}
    >

      <Box
        className="card-info"
        sx={promoBlockStyle.cardInfo}
      >
        {!!card?.category && (
          <Box
            as="span"
            className="card-category"
          >{card.category}</Box>
        )}
        {!!card?.title && (
          <Box as="span" className="card-title" sx={promoBlockStyle.cardTitle} dangerouslySetInnerHTML={{ __html: card.title }} />
        )}

        {!!card?.excerpt && (
          <Box as="span" className="card-excerpt" sx={promoBlockStyle.cardExcerpt} dangerouslySetInnerHTML={{ __html: card.excerpt }} />
        )}
      </Box>
    </Box>
  </Link>
;

const ThreePromoBlocks = ({ cards }: ThreePromoBlocksProps) => {
  return (
    <Box
      sx={{...promoBlockStyle.cardGrid, ...ThreePromoBlocksStyle.grid}}
    >
      {renderCard(cards[0])}

      <Box sx={ThreePromoBlocksStyle.cardGrid}>
        {[...cards.slice(1)].map(card => renderCard(card, true))}
      </Box>
    </Box>
  );
};

export default ThreePromoBlocks;
